// extracted by mini-css-extract-plugin
module.exports = {"guide":"SalesOrder_guide__RCuT4","intro":"SalesOrder_intro__21yZp","intro_1":"SalesOrder_intro_1__14vux"};